import { useFiltersContext } from '@/context'
import { ScheduledCommunicationQueries } from '@/graphql/queries/scheduledCommunications.queries'
import { ScheduledCommunicationList } from '@/types/ScheduledCommunication'
import { formatDate } from '@/util'

import { useGraphql } from '../useGraphql'

export const useScheduledCommunications = () => {
  const [{ scheduledCommunicationsFilters, marketSegmentFilter }] = useFiltersContext()
  const { scheduledCommunicationStatuses, scheduledDatetime } = scheduledCommunicationsFilters
  const { start, end } = scheduledDatetime || {}

  const formattedScheduledDatetime =
    start || end
      ? { start: start && formatDate(start, 'yyyy-MM-dd'), end: end && formatDate(end, 'yyyy-MM-dd') }
      : undefined

  return useGraphql<{ scheduledCommunications: ScheduledCommunicationList[] }>(
    ScheduledCommunicationQueries.QUERY_KEY,
    ScheduledCommunicationQueries.getScheduledCommunications(),
    {
      filter: {
        marketSegmentIds:
          marketSegmentFilter.marketSegmentIds && marketSegmentFilter.marketSegmentIds.length > 0
            ? marketSegmentFilter.marketSegmentIds
            : undefined,
        scheduledCommunicationStatuses:
          scheduledCommunicationStatuses && scheduledCommunicationStatuses?.length > 0
            ? scheduledCommunicationStatuses
            : undefined,
        scheduledDatetime: formattedScheduledDatetime,
      },
    },
    { refetchOnMount: 'always' },
  )
}
